<template>
  <el-dialog
    class="background-settings-modal"
    :visible.sync="modalVisible"
    :close-on-click-modal="true"
    title="Background Settings">

    <!--
    <div class="sub-title">Color or Picture?</div>
    <el-switch
      v-model="clone.displayPictureNotColor"
      active-text="Picture"
      inactive-text="Color">
    </el-switch>
    -->
    <h5 class="">Choose a picture</h5>
    <!--
    <el-upload
      list-type="picture-card"
      action="http://"
      :show-file-list="false"
      :on-success="handleSuccess"
      :before-upload="beforeUpload">
      <img v-if="clone.image" :src="clone.image" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    -->

    <image-selector-mini
      class="mb-4"
      v-model="userSettings['dayplanner.bgPictureOrColor']"
      content="dayplanner"
      bucket="dayplanner_pics"
      :allow-user-upload="false"
      :allow-pexels-search="false"
      :suggestion-text="''" />

    <h5 class="mt-6">Or select a color</h5>

    <ColorSelector
      :selected_color="userSettings['dayplanner.bgPictureOrColor']"
      @color-select="onSelectColor"
      headline="" />

    <!--
    <el-color-picker v-model="userSettings['dayplanner.bgPictureOrColor']"></el-color-picker>
    -->

    <pre v-if="SHOW_DEBUG">{{userSettings['dayplanner.bgPictureOrColor']}}</pre>

    <span slot="footer" class="dialog-footer">
      <el-button @click="modalVisible = false">Cancel</el-button>
      <el-button type="primary" @click="onSaveSettings()">Confirm</el-button>
    </span>

  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      modalVisible: false,
      userSettings: {}
    }
  },
  created() {
    this.userSettings = this.$models.userSettings.getNode( this.$models.user.defaultUserId ).clone();
  },
  methods: {
    showModal() {
      this.modalVisible = true;
    },
    onSelectColor(value) {
      this.userSettings['dayplanner.bgPictureOrColor'] = value;
    },
    onSaveSettings() {
      console.log("this.userSettings", this.userSettings)
      this.userSettings.write();

      this.modalVisible = false
      this.$emit('save');

      /*
      this.$api.user_update_settings_by_prefix({
        data: this.clone,
        prefix: 'backgroundSettings'
      }).then(() => {
        console.log( "Successfully updated user backgroundSettings" );
        this.$emit('save');
      });
      */
    },
  },
};
</script>
